module.exports = __webpack_public_path__ + "static/media/icons.7b69bccd.svg";